import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import moment from "moment";
import { ButtonComponent } from "../../components/Controls/Button/Button";
import * as actions from "../../store/patients/actions";
import { avatar, men1, men2, men3, women1, women2, women3 } from "./../../utils/images";
import TableGridView from "../../components/TableGridView";
import Filterform from "./Filterform";
import "./style.scss";
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';

const MyPatients = ({ intl: { messages } }) => {
  const history = useHistory();
  const [searchValues, setSearchValues] = useState({});
  const lang = localStorage.getItem("lang") || "en";
  const dispatch = useDispatch();  
  const { myPatients } = useSelector((state) => state.patients);
  const user = useSelector((state) => state.auth?.user?.data);

  useEffect(() => {
    //patients list
    dispatch(
      actions?.getMyPatientsRequest({
        page: 1,
        sort: "created_at,desc",
      })
    );
    return () => {
      dispatch(actions.getMyPatientsReceive([]));
    };
  }, [dispatch]);

  //table n grid view render
  const headings = [
    messages.patients.client_name,
    messages.patients.stage,
    messages.patients.source_name,
    messages.patients.inscription_date,
    messages.patients.actions,
  ];

  const mens = [men1, men2, men3];
  const womens = [women1, women2, women3];

  const renderTableData = () => {
    return myPatients?.data?.map((patient, i) => {
      const { name, source_name, request_status_name, created_at } =
        patient;
      return [
        name,
        request_status_name,
        source_name,
         moment(created_at).format("DD[.]MM[.]YYYY  ,  HH:mm:ss"),
         <ButtonComponent
         content={messages.patients.form.view_profile}
         type="button"
         classes={`cyan-button px-8`}
         handleClick={() => {
            history.push(`/patient-preview/${patient.id}`);
         }}
       />,
      ];
    });
  };
  const handlePageChange = (e, page) => {
    return dispatch(
      actions?.getMyPatientsRequest({
        page,
        sort: "created_at,desc",
        ...searchValues,
      })
    );
  };
  const onImgError = (e, x) => {
    e.target.src = avatar;
  };
  const renderGridView = () => {
    if (myPatients?.data?.length > 0) {
      return myPatients?.data?.map((patient, ind) => {
        const {
          created_at,
          name,
          source_name,
          profile_image,
          request_status,
          request_status_name,
          gender_type,
        } = patient;
        return (
          <div className="col-md-4" key={ind}>
            <div className=" grid-col">
              {request_status === 4 && <div className="hold">{messages.appointments.hold}</div>}
              <div className={`grid-col-img status${request_status || 0}`}>
                {profile_image !== null ? (
                  <img
                    src={profile_image}
                    alt="patient img"
                    onError={(e) => onImgError(e)}
                  />
                ) : (
                  <img src={gender_type 
                    ? gender_type === 1 ? mens[Math.floor(Math.random() * mens.length)] : gender_type === 2 ? womens[Math.floor(Math.random() * womens.length)] : avatar
                    : avatar} alt="avatar img" />
                )}
                <span className="status-label">{request_status_name}</span>
              </div>
              <p className="patient_name">{name}</p>
              <div className="d-flex justify-content-center">
                <p className="mx-3">{source_name}</p>
                <p className="">
                {messages.requests.date}: {moment(created_at).format("DD[.]MM[.]YYYY")}
              </p>
                {/* <p className="mx-3">{request_status}</p> */}
              </div>

              <ButtonComponent
                content={messages.patients.form.view_profile}
                type="button"
                classes={`cyan-button px-8`}
                handleClick={() => {
                  history.push(`/patient-preview/${patient.id}`);
                }}
              />
            </div>
          </div>
        );
      });
    } else {
      return <div className="grid_no_data">{messages.noData.no_data}</div>
    } 
  };
  
  return (
    <>
      {myPatients ? (
        <div style={{ padding: '5px 0'}}>
          {user?.role_id !== 4 && user?.role_id !== 6 ? <button className={`myBtn ${lang === 'ar' && 'rtl'}`}
              onClick={(e) => {e.preventDefault(); history.push("/clients/add")}} >
              <AddCircleOutlineOutlinedIcon />{messages.patients.add_new}
          </button> : null}
          <TableGridView
            title={
              <>
                <FormattedMessage
                  values={{
                    total: myPatients?.total,
                    totals: myPatients?.total,
                  }}
                  id="patients.refs_of"
                  defaultMessage={messages.patients.refs_of}
                />
              </>
            }
            Form={<Filterform setSearchValues={setSearchValues} />}
            table={{
              stickyHeader: true,
              headings: headings,
              data: renderTableData(),
              headClass: "bg-white table-head",
              noData: messages.noData.no_data,
            }}
            gridView={renderGridView}
            defaultView="grid"
            pagination={{
              count: myPatients.last_page,
              page: myPatients.current_page,
              handleChange: handlePageChange,
            }}
          />
        </div>
      ) : null}

    </>
  );
};

export default injectIntl(MyPatients);
